/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('ProductView', ["$sce", "ProductData", "ProductSrv", "Product", "SupplierView", "$filter", "SaleData", "OrderData", "UsageProductData", "$locale", "CurrencyManager", "NumberSeparatorType",
    function ($sce, ProductData, ProductSrv, Product, SupplierView, $filter, SaleData, OrderData, UsageProductData, $locale, CurrencyManager, NumberSeparatorType) {

        var ProductView = function (product, prdIndex, parentCategoryView, domainView) {
            this.prdIndex = prdIndex;
            this.domainView = domainView;
            this.categoryType = "product";
            this.categoryTypeSortOrder = 1;
            this.label = "";
            this.code = "";
            this.reference = "";
            this.description = "";
            this.descriptionHtml = "";
            this.buyingPrice = 0;
            this.buyingPriceInput = $filter("currencyFormatFilter")(0);
            this.price = 0;
            this.priceInput = $filter("currencyFormatFilter")(0);
            this.hasQuantity = true;
            this.hasInternetPrice = false;
            this.internetPrice = 0;
            this.internetPriceInput = $filter("currencyFormatFilter")(0);
            this.internetDiscountPercent = 0;
            this.quantity = 0;
            this.quantityInput = 0;
            this.quantityModel = 0;
            this.supplierView = null;
            this.supplierInputLabel = "";
            this.companyImage = null;
            this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
            this.specificImage = null;
            this.isVisibleOnWebSite = true;
            this.isOnHome = false;
            this.homeOrder = 0;
            this.isBuyableOnWebSite = true;
            this.vatView = (domainView && domainView.getDefaultVatView !== undefined) ?
                domainView.getDefaultVatView() : null;
            this.tax = 0;
            //for views
            this.isSelected = false;
            this.isSmsSelected = false;
            this.isNotificationSelected = false;
            this.form = {
                supplierEditMode: false,
                displayError: false,
                displayErrorMobile: false,
                displayErrorLandLine: false,
                displayErrorInternetPrice: false,
                quantityHistory: [],
                qhMessage: false
            };
            if (parentCategoryView) {
                this.parentCategoryView = parentCategoryView;
            }
            if (product) {
                this.loadDataFrom(product);
            }
        }
        ProductView.prototype.getModel = function () {
            if (this.prdIndex != -1) {
                return ProductData.getByIndex(this.prdIndex);
            }
            return null;
        }

        ProductView.prototype.loadDataFrom = function (product) {
            //Assume here than the object in parameter contains only id (must load them)
            this.label = product.label;
            this.code = product.code;
            this.reference = product.reference;
            this.description = product.description;
            this.isOnHome = product.isOnHome;
            this.homeOrder = product.homeOrder;
            this.hasInternetPrice = product.hasInternetPrice;
            this.isVisibleOnWebSite = product.isVisibleOnWebSite;
            this.isBuyableOnWebSite = product.isBuyableOnWebSite;

            if (this.description)
                this.descriptionHtml = $sce.trustAsHtml(this.description.replace("\n", "<br/>"));

            this.price = product.price;
            this.priceInput = $filter('currencyFormatFilter')(this.price);
            this.buyingPrice = product.buyingPrice;
            this.buyingPriceInput = $filter('currencyFormatFilter')(this.buyingPrice);

            if (product.internetPrice != null) {
                this.internetPrice = product.internetPrice;
                if (this.internetPrice == 0 && this.price != 0)
                    this.internetDiscountPercent = 100;
                else
                    this.internetDiscountPercent = Math.round(100 * (100 - 100 * this.internetPrice / this.price)) / 100;
            } else
                this.internetPrice = this.price;
            this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);


            if (product.hasQuantity !== undefined)
                this.hasQuantity = product.hasQuantity;
            this.quantity = product.quantity;
            this.quantityInput = product.quantity;
            this.quantityModel = product.quantity;
            if (product.supplier) {
                if (this.domainView.getSupplierView !== undefined)
                    this.supplierView = this.domainView.getSupplierView(product.supplier);
                if (this.supplierView) {
                    this.supplierInputLabel = this.supplierView.label;
                    this.form.supplierEditMode = true;
                }
            }
            if (product.vat) {
                if (this.domainView && this.domainView.getVatView !== undefined)
                    this.vatView = this.domainView.getVatView(product.vat);
            } else if (this.domainView && this.domainView.getDefaultVatView !== undefined)
                this.vatView = this.domainView.getDefaultVatView();

            this.specificImage = product.specificImage;
            this.image = product.image;
            this.companyImage = product.companyImage;
            if (this.image || this.companyImage)//for ascendencing compatibility
                this.specificImage = true;

            if (this.parentCategoryView && this.image == null && this.specificImage == false)
                this.image = this.parentCategoryView.image;

            if (this.parentCategoryView && this.companyImage == null && this.specificImage == false)
                this.companyImage = this.parentCategoryView.companyImage;

            if (this.companyImage)
                this.imageDisplayed = this.companyImage;
            else
                this.imageDisplayed = this.image;
            this.updateTax();
        }
        ProductView.prototype.updateTax = function () {
            if (this.vatView)
                this.tax = this.price - this.price * 100 / (100 + this.vatView.tax);
        }

        ProductView.prototype.checkHasWrongInternetPrice = function () {
            if (this.hasInternetPrice && (this.internetPrice === 0 || this.internetPrice == null) && this.price === 0) {
                this.form.displayErrorInternetPrice = true;
            } else {
                this.form.displayErrorInternetPrice = false;
            }
        };


        ProductView.prototype.updatePriceInputArrow = function (number) {
            if (this.priceInput != null && typeof this.priceInput === 'string') {
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                var price = parseFloat(priceStr);
                if (isNaN(price))
                    this.price = null
                else {
                    price += number;
                    this.priceInput = $filter('currencyFormatFilter')(price);
                    this.onPriceInputChange();
                }
            }
        }
        ProductView.prototype.onPriceInputChange = function () {
            if (this.priceInput != null && typeof this.priceInput === 'string') {
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                var price = parseFloat(priceStr);
                if (isNaN(price))
                    this.price = null
                else
                    this.price = price;
                this.updateTax();
            }
            this.checkHasWrongInternetPrice();
        };

        ProductView.prototype.onQuantityInputChange = function () {
            if (this.quantityInput != null) {
                var quantity = parseInt(this.quantityInput);
                if (isNaN(quantity))
                    this.quantity = null
                else
                    this.quantity = quantity;
            } else
                this.quantity = null
        }
        ProductView.prototype.updateQuantityInputArrow = function (number) {
            if (this.quantityInput != null) {
                var quantity = parseInt(this.quantityInput);
                if (isNaN(quantity))
                    this.quantity = null;
                else {
                    quantity += number;
                    this.quantityInput = quantity;
                    this.onQuantityInputChange();
                }
            }
        }
        ProductView.prototype.updateBuyingPriceInputArrow = function (number) {
            if (this.buyingPriceInput != null && typeof this.buyingPriceInput === 'string') {
                var buyingPriceStr = CurrencyManager.getPriceFromPriceInput(this.buyingPriceInput);
                var buyingPrice = parseFloat(buyingPriceStr);
                if (isNaN(buyingPrice))
                    this.buyingPrice = null
                else {
                    buyingPrice += number;
                    this.buyingPriceInput = $filter('currencyFormatFilter')(buyingPrice);
                    this.onBuyingPriceInputChange();
                }


            }
        }
        ProductView.prototype.onBuyingPriceInputChange = function () {
            if (this.buyingPriceInput != null && typeof this.buyingPriceInput === 'string') {
                var buyingPriceStr = CurrencyManager.getPriceFromPriceInput(this.buyingPriceInput);
                var buyingPrice = parseFloat(buyingPriceStr);
                if (isNaN(buyingPrice))
                    this.buyingPrice = null
                else
                    this.buyingPrice = buyingPrice;
            }
        }

        ProductView.prototype.initInternetPrice = function () {
            if (this.hasInternetPrice && this.internetPrice == 0) {
                this.internetPrice = this.price;
                this.internetPriceInput = $filter('currencyFormatFilter')(this.internetPrice);
                this.onInternetPriceInputChange();
            }
            this.checkHasWrongInternetPrice();
        };

        ProductView.prototype.updateInternetPriceInputArrow = function (number) {
            if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
                var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
                var internetPrice = parseFloat(internetPriceStr);
                if (isNaN(internetPrice))
                    this.internetPrice = null
                else {
                    if ((internetPrice + number) < 0)
                        internetPrice = 0;
                    else if ((internetPrice + number) < this.price)
                        internetPrice += number;
                    else
                        internetPrice = this.price;
                    this.internetPriceInput = $filter('currencyFormatFilter')(internetPrice);
                }
                this.onInternetPriceInputChange();
            }
        }
        ProductView.prototype.onInternetPriceInputChange = function () {
            if (this.internetPriceInput != null && typeof this.internetPriceInput === 'string') {
                var internetPriceStr = CurrencyManager.getPriceFromPriceInput(this.internetPriceInput);
                var internetPrice = parseFloat(internetPriceStr);
                if (isNaN(internetPrice))
                    this.internetPrice = null
                else
                    this.internetPrice = internetPrice;

                if (this.internetPrice == 0 && this.price != 0)
                    this.internetDiscountPercent = 100;
                else
                    this.internetDiscountPercent = Math.round(10000 * (100 - 100 * this.internetPrice / this.price)) / 10000;
            }
            this.checkHasWrongInternetPrice();
        };

        ProductView.prototype.isChanged = function () {
            var product = this.getModel();
            if (product) {
                var image = product.image;
                if (image == null && product.parentCategory && product.specificImage == false)
                    image = product.parentCategory.image;
                var companyImage = product.companyImage;
                if (companyImage == null && product.parentCategory && product.specificImage == false)
                    companyImage = product.parentCategory.companyImage;

                var vat = null;
                if (this.vatView && this.domainView.getDefaultVatView() != this.vatView)//null == default
                    vat = this.vatView.getModel();

                var supplierChanged = false;
                if (this.supplierView) {
                    if (!product.supplier)
                        supplierChanged = true;
                    else
                        supplierChanged = this.supplierView.getModel() != product.supplier;
                    if (!supplierChanged)
                        supplierChanged = this.supplierView.isChanged();
                } else
                    supplierChanged = product.supplier != null;

                return (
                    this.label != product.label ||
                    this.code != product.code ||
                    this.reference != product.reference ||
                    this.description != product.description ||
                    this.buyingPrice != product.buyingPrice ||
                    this.hasInternetPrice != product.hasInternetPrice ||
                    this.isVisibleOnWebSite != product.isVisibleOnWebSite ||
                    this.isBuyableOnWebSite != product.isBuyableOnWebSite ||
                    this.internetPrice != product.internetPrice ||
                    this.price != product.price ||
                    this.quantity != product.quantity ||
                    this.hasQuantity != product.hasQuantity ||
                    this.specificImage != product.specificImage ||
                    this.image !== image ||
                    this.companyImage !== companyImage ||
                    supplierChanged ||
                    vat !== product.vat ||
                    this.isOnHome !== product.isOnHome ||
                    this.homeOrder !== product.homeOrder);
            } else
                return true;

        }
        ProductView.prototype.activeSupplierEditMode = function () {
            this.supplierView = new SupplierView(null, -1, this.domainView);
            if (this.supplierInputLabel && typeof this.supplierInputLabel == "string")
                this.supplierView.label = this.supplierInputLabel;
            this.form.supplierEditMode = true;
        };
        ProductView.prototype.cancelSupplierEditMode = function () {
            this.supplierView = null;
            this.supplierInputLabel = "";
            this.form.supplierEditMode = false;
        };

        ProductView.prototype.onSupplierSelect = function (supplierView) {
            //call when supplier is selected
            this.supplierView = supplierView;
            this.form.supplierEditMode = true;

        };
        ProductView.prototype.setImage = function (image) {
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;
        };
        ProductView.prototype.setCompanyImage = function (companyImage) {
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        };

        ProductView.prototype.getClone = function () {
            var clone = new ProductView(null, -1, this.parentCategoryView, this.domainView);
            clone.label = this.label;
            clone.code = this.code;
            clone.reference = this.reference;
            clone.description = this.description;
            clone.descriptionHtml = this.descriptionHtml;
            clone.buyingPrice = this.buyingPrice;
            clone.buyingPriceInput = this.buyingPriceInput;
            clone.price = this.price;
            clone.priceInput = this.priceInput;
            clone.hasQuantity = this.hasQuantity;
            clone.hasInternetPrice = this.hasInternetPrice;
            clone.internetPrice = this.internetPrice;
            clone.internetPriceInput = this.internetPriceInput;
            clone.internetDiscountPercent = this.internetDiscountPercent;
            clone.quantity = 0;
            clone.quantityInput = 0;
            clone.quantityModel = 0;
            clone.supplierView = this.supplierView;
            clone.supplierInputLabel = this.supplierInputLabel;
            if (this.imageDisplayed) {
                clone.setImage(this.imageDisplayed);
            }
            if (this.companyImage) {
                clone.setCompanyImage(this.companyImage);
            }
            clone.specificImage = this.specificImage;
            clone.isVisibleOnWebSite = this.isVisibleOnWebSite;
            clone.isOnHome = this.isOnHome;
            clone.homeOrder = this.homeOrder;
            clone.isBuyableOnWebSite = this.isBuyableOnWebSite;
            clone.vatView = this.vatView;
            clone.tax = this.tax;

            return clone;
        }

        ProductView.prototype.copyDataTo = function (product) {
            //Assume here than the object in parameter contains only id (must load them)
            product.label = this.label;
            product.code = this.code;
            product.reference = this.reference;
            product.description = this.description;
            product.buyingPrice = this.buyingPrice;
            product.price = this.price;
            product.originalPrice = this.originalPrice;
            product.quantity = this.quantity;
            this.quantityModel = this.quantity;//Align quantity
            product.hasQuantity = this.hasQuantity;
            product.hasInternetPrice = this.hasInternetPrice;
            product.isOnHome = this.isOnHome;
            product.homeOrder = this.homeOrder;
            product.internetPrice = this.internetPrice;

            if (this.vatView && this.domainView.getDefaultVatView() != this.vatView)//do not set if = default -> allow to change default
                product.vat = this.vatView.getModel();
            else
                product.vat = null;
            if (this.supplierView) {
                var supplier = this.supplierView.getModel();
                if (supplier !== product.customer) {
                    if (product.customer)
                        product.customer.removeProduct(product);
                    if (supplier)
                        supplier.addProduct(product);
                    product.supplier = supplier;
                }
            } else
                product.supplier = null;
            product.image = this.image;
            product.companyImage = this.companyImage;
            product.specificImage = this.specificImage;
            product.isVisibleOnWebSite = this.isVisibleOnWebSite;
            product.isBuyableOnWebSite = this.isBuyableOnWebSite;
        }
        ProductView.prototype.onSpecificImageChange = function () {
            if (!this.specificImage) {
                this.image = null;
                this.companyImage = null;
            }
        }
        ProductView.prototype.updateModel = function (noQuantity) {
            if (this.isChanged()) {
                var product = this.getModel();
                if (product == null) {
                    product = new Product();
                    this.prdIndex = ProductData.getIndexOf(product);
                }

                if (!this.specificImage && this.parentCategoryView !== undefined && this.parentCategoryView.label !== "Racine") {
                    this.image = this.parentCategoryView.image;
                    product.image = this.image;
                }

                if (this.supplierView) {
                    if (!this.supplierView.getModel() && this.domainView)//Add to view
                        this.domainView.addSupplierView(this.supplierView);
                    this.supplierView.updateModel(false);
                }
                this.copyDataTo(product);

                var category = this.parentCategoryView.getModel();
                if (category && category !== product.parentCategory) // change of category
                {
                    if (product.parentCategory)
                        product.parentCategory.removeProduct(product);
                    category.addProduct(product);
                }
                if (noQuantity !== undefined && noQuantity)
                    ProductSrv.saveNoQuantity(product);
                else
                    ProductSrv.save(product);
            }
        }


        ProductView.prototype.removeModel = function () {
            var product = this.getModel();
            if (product != null) {
                product.parentCategory.removeProduct(product);
                ProductSrv.remove(product);
            }
        }
        ProductView.prototype.reloadModel = function () {
            var product = this.getModel();
            if (product == null) {
                this.parentCategoryView.removeProductView(this);
            } else {
                this.loadDataFrom(product);
            }
            if (this.supplierView)
                this.supplierView.reloadModel();
        }
        ProductView.prototype.restoreModel = function () {   //undeleted
            var product = this.getModel();
            if (product) {
                if (product.parentCategory)
                    product.parentCategory.addProduct(product);
                ProductSrv.restore(product);
            }

        }
        ProductView.prototype.getQuantityHistory = function () {
            var product = this.getModel();
            var productView = this;
            if (product) {
                this.form.quantityHistory = null;
                ProductSrv.getQuantityHistory(product,
                    function (productHistory) {
                        var sale, saleNumber, order, orderNumber, up, upNumber, isCanceled;
                        productView.form.qhMessage = false;
                        if (productHistory && productHistory.productVersions) {
                            productView.form.quantityHistory = [];

                            //update quantity
                            productView.quantity = product.quantity;
                            productView.quantityModel = product.quantity;
                            productView.quantityInput = product.quantity;

                            for (var i = 0; i < productHistory.productVersions.length; i++) {
                                isCanceled = false;
                                saleNumber = null;
                                if (productHistory.productVersions[i].saleId) {
                                    sale = SaleData.getById(productHistory.productVersions[i].saleId);
                                    if (sale) {
                                        saleNumber = sale.saleNumber;
                                        isCanceled = (i > 0) && (productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity) > 0 && sale.status == "canceled";
                                    }
                                    if (!saleNumber)
                                        saleNumber = "En attente";

                                }
                                orderNumber = null;
                                if (productHistory.productVersions[i].orderId) {
                                    order = OrderData.getById(productHistory.productVersions[i].orderId);
                                    if (order) {
                                        orderNumber = order.orderNumber;
                                        isCanceled = (i > 0) && (productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity) < 0;
                                    }
                                }
                                upNumber = null;
                                if (productHistory.productVersions[i].usageProductId) {
                                    up = UsageProductData.getById(productHistory.productVersions[i].usageProductId);
                                    if (up) {
                                        upNumber = up.upNumber;
                                        isCanceled = (i > 0) && (productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity) > 0;

                                    }
                                }
                                if (productHistory.productVersions[i].hide)
                                    productView.form.qhMessage = true;
                                else
                                    productView.form.quantityHistory.push({
                                        versionDate: new Date(productHistory.productVersions[i].versionDate),
                                        quantity: productHistory.productVersions[i].quantity,
                                        delta: (i > 0) ? productHistory.productVersions[i].quantity - productHistory.productVersions[i - 1].quantity : productHistory.productVersions[i].quantity,
                                        saleNumber: saleNumber,
                                        orderNumber: orderNumber,
                                        upNumber: upNumber,
                                        isCanceled: isCanceled,
                                        directSave: productHistory.productVersions[i].directSave

                                    });
                            }
                        }

                    });
            }
        }
        ProductView.prototype.canSave = function () {
            if (!this.form.quantityHistory || this.form.displayErrorInternetPrice)
                return false;

            if (this.supplierView && this.supplierView.canSave != undefined)
                if (!this.supplierView.canSave() || this.form.displayErrorLandLine || this.form.displayErrorMobile)
                    return false;
            if (this.supplierInputLabel && this.supplierInputLabel != "" && !this.supplierView)//must use button New supplier
                return false;

            if
            (
                (this.label && this.label != "") //titre
                && (this.buyingPrice != null && this.buyingPrice >= 0) //prix (décimal)
                && (this.price != null && this.price >= 0) //prix (décimal)
                && (!this.hasQuantity || this.quantity != null)
                && (this.internetPrice != null && this.internetPrice >= 0) //prix (décimal)
            ) {
                return true;
            } else {
                return false;
            }
        }
        ProductView.prototype.search = function (searchedTextLC) {
            if (!searchedTextLC) {
                return false;
            }

            if (this.label.toLowerCase().indexOf(searchedTextLC) !== -1 || (this.image && this.image.keyWords && this.image.keyWords.indexOf(searchedTextLC) !== -1)) {
                return true;
            }

            return false;
        };

        return ProductView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/ProductView.js